export type GoogleMapMarker = google.maps.Marker;

export type GoogleMap = google.maps.Map;

export type GoogleMapLatLngBounds = google.maps.LatLngBounds;

export type GoogleMapLatLngLiteral = google.maps.LatLngLiteral;

export type GoogleMapTransitLayer = google.maps.TransitLayer;

export type GoogleMapTypeStyle = google.maps.MapTypeStyle;

export enum MapMarkerType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export interface MapMarker extends GoogleMapLatLngLiteral {
  id: number | string,
  title: string,
  type: MapMarkerType,
}

export interface SearchMapMarker extends MapMarker {
  groupedMarkerTitles?: string[],
}

export type CustomMarkerAnchorPoint = 'BOTTOM_RIGHT' | 'BOTTOM_LEFT' | 'TOP_RIGHT' | 'TOP_LEFT';
